// extracted by mini-css-extract-plugin
export default {"container":"Section_container__-dtXC","txt-title":"Section_txt-title__n7THH"};